import axios from "axios";

const hyu = process.env.VUE_APP_HYU

const state = () => ({
    dealers: [],
    district: [],
    isGov: false,
});

const getters = {
    getDistrict: state => {
        return state.district
    },
    getDealersByDistrict: state => val => {
        let res = state.dealers.filter(el => el.district == val)
        res.splice(0, 0, { objectId: '', designation: 'Selecione um concessionário' })
        return res
    },
    getDealerKeyValueById: state => (id, key) => {
        let res = state.dealers.find(el => el.objectId === id)?.[key]
        return res
    }
};

const mutations = {
    SAVE_DATA(state, payload){
        state.dealers = payload.dealers
        let arr = payload.district.map(el => {
            return {
                objectId: el,
                designation: el
            }
        });
        state.district = arr
        state.district.splice(0, 0, { objectId: '', designation: 'Selecione um distrito' })
    },
    UPDATE_STATE(state, payload){
        state = Object.assign(state, payload);
    }
};

const actions = {
    fetchDealers({ commit }, ids){
        if(ids) commit('UPDATE_STATE', { isGov: true })
        let str = (ids) ? ids : 'all';
        let url = hyu + process.env.VUE_APP_API_DEALERS_API  + str
        axios.get(url)
        .then(res => commit('SAVE_DATA', res.data))
        .catch(err => console.log(err))
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
